import { ArrowUturnLeftIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router';
import Button from '../UI/Button';

function Unauthorized() {
  const navigate = useNavigate();
  return (
    <div className='mx-auto w-full flex flex-col text-center items-center py-5 h-screen/75 justify-center bg-white'>
      <h1 className='text-4xl'>Access Denied</h1>
      <h3>You are not authorized to access this page</h3>
      <Button
        btnStyle='btn-primary'
        customClassName='mt-5'
        label='Back to Home'
        icon={<ArrowUturnLeftIcon className='h-5 w-5' />}
        onClick={() => navigate('/auth/sign_in', { replace: true })}
      />
    </div>
  );
}

export default Unauthorized;
